// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__0PZ2Q","error":"TextInput_error__fGp1q"};